const customErrorEvents = {
  BROWSER_UNSUPPORTED: 'Your current browser is not supported, please update your browser',
  UNREGISTERED_ERROR: 'Unregistered Flow Player Error',
  VIDEO_UNAVAILABLE: 'The video is currently unavailable.',
};

const flowPlayerUIClasses = {
  BACK_TEN: 'skip-ten__button skip-ten__button--back',
  FORWARD_TEN: 'skip-ten__button skip-ten__button--forward',
  FULLSCREEN: 'fp-fullscreen fp-icon',
  PLAY: 'fp-icon fp-playbtn',
  ROOT: 'fp-ui',
  SCRUBBER: 'fp-timeline fp-bar',
  SCRUB_BACKWARD: 'fp-progress fp-color animated',
  SCRUB_FORWARD: 'fp-buffer',
};

// Flow Player returns an error event number which are defined here:
// https://flowplayer.com/help/developers/flowplayer-7/api#events
const flowPlayerErrorEvents = {
  1: 'Video loading aborted',
  2: 'Network error',
  3: 'Video not properly encoded',
  4: 'Video file not found',
  5: 'Unsupported video',
  6: 'Skin not found',
  7: 'SWF file not found',
  8: 'Subtitles not found',
  9: 'Invalid RTMP URL',
  10: 'Unsupported video format. Try installing Adobe Flash',
};

// These events are defined in the Flow Player spec:
// https://flowplayer.com/help/developers/flowplayer-7/api#events
const videoPlaybackEvents = {
  BUFFER: 'buffer',
  CUEPOINT: 'cuepoint',
  ERROR: 'error',
  FINISH: 'finish',
  HLS_ERROR: 'hlsError',
  HLS_LEVEL_SWITCH: 'hlsLevelSwitch',
  PAUSE: 'pause',
  PROGRESS: 'progress',
  READY: 'ready',
  RESUME: 'resume',
  RESUME_SEEK: 'resume seek',
  SEEK: 'seek',
  TEN_SECONDS: '10s',
  WATCHING: 'watching',
};

// These events are based on the segment video tracking guidelines:
// https://segment.com/docs/spec/video/
const videoTrackingEvents = {
  BUFFER_COMPLETED: 'Video Playback Buffer Completed',
  BUFFER_STARTED: 'Video Playback Buffer Started',
  COMPLETED: 'Video Playback Completed',
  CUEPOINT: 'Video Playback Cuepoint',
  ERROR: 'Video Playback Error',
  INTERRUPTED: 'Video Playback Interrupted',
  PAUSED: 'Video Playback Paused',
  PLAYING: 'Video Content Playing',
  QUALITY_UPDATED: 'Video Quality Updated',
  RESUMED: 'Video Playback Resumed',
  SEEK_COMPLETED: 'Video Playback Seek Completed',
  SEEK_STARTED: 'Video Playback Seek Started',
  STARTED: 'Video Playback Started',
};

export {
  customErrorEvents,
  flowPlayerErrorEvents,
  flowPlayerUIClasses,
  videoPlaybackEvents,
  videoTrackingEvents,
};
